import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => {
  return {
    filtersSection: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      marginBottom: "24px",
      gap: "12px",

      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
      },
    },
    inputwrapper: {
      width: "100% !important",
      maxWidth: "392px",
      minWidth: "164px",

    },
    autoCompleteInput: {
      minWidth: "190px",
      [theme.breakpoints.down("420")]: {
        maxWidth: "165px",
        width: "100% !important",
        minWidth: "initial",
      },
    },
    leftSection: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",

      flexWrap: "wrap",
      gap: "12px",

      [theme.breakpoints.down("md")]: {
        width: "100%",
      },

      [theme.breakpoints.down("426")]: {
        width: "100%",
        justifyContent: "flex-start",
        "& .MuiBox-root": {
          width: "100%",
        },
      },
    },
    rightSection: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "12px",
    },
    selectFields: {
      display: "flex",
      gap: "12px",
      [theme.breakpoints.down("769")]: {
        width: "100%",
        flexWrap: "wrap",

        "& .MuiBox-root": {
          width: "186px",
        },
      },
    },
    customSelect: {
      [theme.breakpoints.up("426")]: {
        width: "191px !important",
      },
      [theme.breakpoints.down("426")]: {
        width: "100% !important",
      },
    },
    customInputContainer: {
      width: "191px !important",
      [theme.breakpoints.down("426")]: {
        width: "100% !important",
      },
    },
    phoneInputWrapper: {
      width: "291px !important",
      [theme.breakpoints.down("426")]: {
        width: "100% !important",
      },
    },
    customAutocomplete: {
      width: "191px !important",
      [theme.breakpoints.down("426")]: {
        width: "100% !important",
      },
    },
    dateRanges: {
      width: "max-content",
      [theme.breakpoints.down("426")]: {
        width: "100%",
      },
    },
  };
});
